import styled from "styled-components/macro"
import { InformationMessage, Title } from "@humanpredictiveintelligence/myqvt-library"

export const Container = styled.div`
  height: 100%;
  padding: 1rem;

  position: relative;
  display: flex;
  flex-direction: column;
  gap: 1rem;
`

export const FormSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  height: 100%;
  overflow: auto;
`

export const Heading = styled(Title)`
  display: flex;
  margin: 0;
`

export const SurveyUsedWarning = styled(InformationMessage)`
  min-height: 3rem;
  overflow: hidden;
`

export const BottomSection = styled.div`
  margin-top: auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 24px;
`

export const FormActions = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;
`

export const Actions = styled.div`
  display: flex;
  gap: 16px;
`

export const Validators = styled.ul`
  margin: 0;
`

export const Validator = styled.li<ValidatorProps>`
  font-size: 14px;

  color: ${({ $isValid, theme }) => $isValid
    ? theme.colors.success
    : theme.colors.danger
};
`

interface ValidatorProps {
  $isValid: boolean,
}
